export default {
  title: 'blue',

  colors: {
    twitter: '#33A1F2',
    darkhover: '#011017',
    lighthover: '#2C8ED6',
  },
};